import { keyframes, styled } from "goober";
import type { ComponentProps } from "react";
import {
  activityAnimationPeriod,
  alignToTimeline,
} from "./ActivityAnimationContext";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

const Pulse = styled("span")`
  display: flex;
  align-items: center;

  &[data-pending="true"] {
    animation: ${pulse} ${activityAnimationPeriod} ease-in-out infinite;
  }
`;

export function PulsingIcon(props: ComponentProps<typeof Pulse>) {
  return <Pulse {...props} onAnimationStart={alignToTimeline} />;
}
